/* eslint-disable vue/experimental-script-setup-vars */
<template>
    <form-element :label="label" :required="required">
        <v-text-field
            v-if="mask.length > 0"
            v-model="model"
            v-mask="mask"
            v-bind="baseStyle"
            :class="[
                { 'mt-n4': $vuetify.breakpoint.smAndUp && marginTop },
                { 'mt-2': $vuetify.breakpoint.smAndUp && !marginTop },
                { 'mt-n3': $vuetify.breakpoint.smAndDown && marginTop },
                { 'mt-1': $vuetify.breakpoint.smAndDown && !marginTop },
            ]"
            :prepend-inner-icon="icon"
            :placeholder="placeholder"
            :hint="hint"
            :validate-on-blur="true"
            :persistent-hint="persistentHint"
            :rules="rules"
            :label="label"
            :disabled="disabled"
            :dusk="name"
            :required="required"
            @input="$emit('input', model)"
            @blur="$emit('blur', model)"
            @change="$emit('change', model)"
        ></v-text-field>
        <v-text-field
            v-else
            v-model="model"
            v-bind="baseStyle"
            :class="[
                { 'mt-n4': $vuetify.breakpoint.smAndUp && marginTop },
                { 'mt-2': $vuetify.breakpoint.smAndUp && !marginTop },
                { 'mt-n3': $vuetify.breakpoint.smAndDown && marginTop },
                { 'mt-1': $vuetify.breakpoint.smAndDown && !marginTop },
            ]"
            :prepend-inner-icon="icon"
            :placeholder="placeholder"
            :hint="hint"
            :persistent-hint="persistentHint"
            :rules="rules"
            :label="label"
            :disabled="disabled"
            :dusk="name"
            :required="required"
            @input="$emit('input', model)"
            @blur="$emit('blur', model)"
            @change="$emit('change', model)"
        ></v-text-field>
    </form-element>
</template>
<script>
import FormElement from "./FormElement";
import { mask } from "vue-the-mask";

export default {
    name: "form-text-field",
    directives: {
        mask,
    },
    components: {
        FormElement,
    },
    props: {
        value: {
            type: [String, Number],
            required: true,
        },
        required: {
            type: Boolean,
            required: false,
            default: false,
        },
        label: {
            type: String,
            required: false,
            default: "",
        },
        icon: {
            type: String,
            required: false,
            default: "",
        },
        placeholder: {
            type: String,
            required: false,
            default: "",
        },
        name: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        mask: {
            type: [String],
            required: false,
            default: "",
        },
        hint: {
            type: String,
            required: false,
            default: "",
        },
        persistentHint: {
            type: Boolean,
            required: false,
            default: false,
        },
        rules: {
            type: Array,
            required: false,
            default: () => [],
        },
        marginTop: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            model: this.value,
            error: false,
            baseStyle: {
                height: "40",
                solo: true,
                color: "primary",
            },
        };
    },
    watch: {
        value() {
            this.model = this.value;
        },
    },
    mounted() {},
};
</script>

<style scoped>
</style>